import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

/**
 * useAuth Hook
 * Custom hook to access authentication context
 * 
 * @returns {Object} Auth context value containing:
 *   - user: Current user object or null
 *   - isLoading: Boolean indicating if auth state is being initialized
 *   - isAuthenticated: Boolean indicating if user is authenticated
 *   - login: Function to log in a user
 *   - logout: Function to log out the current user
 *   - updateUser: Function to update user state
 *   - refreshUser: Function to refresh user data from server
 * 
 * @throws {Error} If used outside of AuthProvider
 * 
 * @example
 * const { user, login, logout, isAuthenticated } = useAuth();
 */
export default function useAuth() {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}







